import api from './client';

export interface TenantBranding {
  logo_url: string | null;
  favicon_url: string | null;
  app_name: string;
  primary_color: string;
  secondary_color: string;
  background_color: string;
  font_heading: string;
  font_body: string;
  custom_css: string | null;
}

export async function fetchBranding() {
  const res = await api.get<TenantBranding>('/branding');
  return res.data;
}

export async function updateBranding(data: Partial<TenantBranding>) {
  const res = await api.put<TenantBranding>('/branding', data);
  return res.data;
}

export async function uploadLogo(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post('/branding/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}
